import { safeDefine } from "../../registration/safe-define.js";
import { NeutralVideoSkinElement } from "../../presets/video/neutral-skin.js";
import "../../internal/skins/neutral-video/register.js";
//#region src/define/video/neutral-skin.ts
safeDefine(NeutralVideoSkinElement);
//#endregion

//# sourceMappingURL=neutral-skin.js.map